// roles.js
// JSON for role selection — used in SelectRole.jsx
// property_label / property_description → shown when context="property"
// project_label  / project_description  → shown when context="project"

const roles = [
  {
    id: "owner",
    property_label:       "Owner",
    property_description: "I directly own this property and want to list it myself.",
    project_label:        " Owner",
    project_description:  "I am the developer or owner of this project.",
  },
  {
    id: "agent",
    property_label:       "Agent / Broker",
    property_description: "I am a licensed agent or broker representing the property owner.",
    project_label:        "Agent / Builder / Mediator",
    project_description:  "I am an agent or channel partner representing this project.",
  },
];

export default roles;